<div class="layout-footer">
    <img src="assets/images/TNP_logo_DARK.png" alt="Logo" width="10%" class="mr-2"/>
    -
    <img src="assets/images/eicon-logo.png" alt="Logo" width="10%" class="mr-2"/>
</div>
